module.exports = __webpack_public_path__ + "img/season-light.d6f5c645.svg";